module.exports = __webpack_public_path__ + "static/img/introduction-barometer-development.c40a31c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/introduction/introduction-barometer-development.jpg
// module id = CyiE
// module chunks = 0